import React from "react"
import {ColumnContainer} from "./component"

export type Viewports = "xs" | "sm" | "md" | "lg" | "xl"
export type NumberOfColumns = 1 | 2 | 3
export type Width = `${string}${"px" | "%" | "rem" | "em"}`
export type ColumnsDefinition = {
    [key in Viewports]:
        | {
              [P in NumberOfColumns]?: Width
          }
        | Width
}

export type ResponsiveColumnsProps = {
    /**
     * The number of vertical columns to be used
     */
    nrOfColumns: number
    /**
     * Defines the container width per each viewport + column combination. eg: 
     * {
        xs: "100%",    <--- 100% means for all number of columns
        sm: "100%",
        md: "320px",
        lg: {
            1: "230px",
            2: "340px",
            3: "340px",
        },
        xl: {
            1: "230px",
            2: "366px",
            3: "366px",
        },
    }
     */
    columnsDefinition?: ColumnsDefinition
    children: React.ReactNode
    /**
     * The gap/space between columns.
     */
    gap: string
    style?: React.CSSProperties
    /**
     * Proxy for the rest of the props. Eg: datatest-id
     */
    [key: string]: any
}
export type ColumnProps = Pick<ResponsiveColumnsProps, "gap" | "nrOfColumns">

export const ResponsiveColumns = ({
    nrOfColumns,
    columnsDefinition,
    children,
    gap,
    style,
    ...rest
}: ResponsiveColumnsProps) => {
    return (
        <ColumnContainer
            nrOfColumns={nrOfColumns}
            columnsDefinition={columnsDefinition}
            gap={gap}
            style={style}
            {...rest}
        >
            {children}
        </ColumnContainer>
    )
}
